import PriceCalculator from './PriceCalculator';

const SELECTOR = '[data-complete-timesheet]';
const FORM_FIELDS = `${SELECTOR} #additional-charges`;
const SERVICE_FIELDS = `${SELECTOR} #service-charge`;
const SERVICE_COST = '[data-service-cost] [data-unit-price]';
const ADD_COST_BUTTON = '[data-add-cost]';
const SUBMIT_BUTTON = '[data-submit-form]';
const ADDITIONAL_ITEMS_CONTAINER = '[data-additional-costs]';
const TOTAL_CONTAINER = '[data-total]';
const TOTAL_PAYABLE_CONTAINER = '[data-total-payable]';
const ITEMS_PRICES = '[data-timesheet-summary] [data-unit-price]';
const GST_CONTAINER = '[data-gst-rate]';
const DESCRIPTION_INPUT = '[data-description-field]';
const PRICE_INPUT = '[data-price-input]';
const QUANTITY_INPUT = '[data-quantity-field]';

class CompleteTimesheet {
  constructor() {
    this.form = $(SELECTOR);
    if (!this.form) {
      return;
    }
    this.formFields = $(FORM_FIELDS);
    this.serviceFields = $(SERVICE_FIELDS);
    this.serviceCost = $(SERVICE_COST);
    this.addCostButton = $(ADD_COST_BUTTON);
    this.addCostButtonText = $(`${ADD_COST_BUTTON} span`);
    this.submitButton = $(SUBMIT_BUTTON);
    this.itemsContainer = $(ADDITIONAL_ITEMS_CONTAINER);
    this.totalContainer = $(TOTAL_CONTAINER);
    this.totalPayableContainer = $(TOTAL_PAYABLE_CONTAINER);
    this.merchantFeeWrapper = $('[data-merchant-fee-rate]');
    this.merchantFeeRate = this.merchantFeeWrapper.data('merchant-fee-rate');
    this.marketplaceFeeRate = this.merchantFeeWrapper.data('marketplace-fee-rate');
    this.gstWrapper = $(GST_CONTAINER);
    this.gstRate = this.gstWrapper.data('gst-rate');
    if (this.form.find('.form-group.has-error').length > 0 && this.formFields.hasClass('hidden')) {
      this.toggle();
    } else if (this.formFields.hasClass('hidden')) {
      this.form.find('fieldset').attr('disabled', 'disabled');
    }
    this.attachEventHandlers();
  }

  attachEventHandlers() {
    this.addCostButton.on('click', () => {
      this.toggle();
    });
    this.serviceFields.on('keyup', 'input', () => {
      this.updateTotalService();
    });
    this.formFields.on('keyup', 'input', () => {
      this.updateTotalLineItems();
    });
    this.submitButton.on('click', () => {
      this.submitForm();
    });
    $('#additional-charges').on('cocoon:after-remove', () => {
      this.updateTotalLineItems();
    });
  }

  toggle() {
    this.formFields.toggleClass('hidden');
    this.updateTotalLineItems();
    $(`${ADD_COST_BUTTON} i`).toggleClass('fa-minus');
    if (this.formFields.is(':visible')) {
      this.form.find('fieldset').attr('disabled', false);
      this.addCostButtonText.html('REMOVE ADDITIONAL COST');
    } else {
      this.form.find('fieldset').attr('disabled', 'disabled');
      this.addCostButtonText.html('ADD ADDITIONAL COST');
    }
  }

  updateTotalService() {
    let quantity = this.serviceFields.find(QUANTITY_INPUT).val();
    let price = this.serviceFields.find(PRICE_INPUT).val();
    let calculator = new PriceCalculator(
      price,
      quantity,
      this.merchantFeeRate,
      this.marketplaceFeeRate,
      this.gstRate
    );
    this.serviceCost.data('unit-price', calculator.subtotal());
    this.serviceCost.html(`$${calculator.subtotal().toFixed(2)}`);
    this.updateTotalLineItems();
  }
  updateTotalLineItems() {
    let total = 0;
    let subtotal = 0;
    let quantity = 0;
    let price = 0;
    let totalUnitPrice = 0;
    this.itemsContainer.html('');
    this.formFields.find('fieldset:visible').each((index, element) => {
      quantity = parseFloat(
        $(element)
          .find(QUANTITY_INPUT)
          .val()
      );
      price =
        Math.ceil(
          parseFloat(
            $(element)
              .find(PRICE_INPUT)
              .val() * 100
          )
        ) / 100;
      subtotal = quantity * price;
      total = total + subtotal;
      this.itemsContainer.append(this.buildLineItem($(element), subtotal));
    });
    $(ITEMS_PRICES).each(function() {
      totalUnitPrice = totalUnitPrice + parseFloat($(this).data('unit-price'));
    });
    let calculator = new PriceCalculator(
      totalUnitPrice,
      1,
      this.merchantFeeRate,
      this.marketplaceFeeRate,
      this.gstRate
    );
    this.gstWrapper.html(`$${calculator.gst()}`);
    this.totalContainer.html(`$${calculator.totalEarned()}`);
    this.totalPayableContainer.html(`$${calculator.totalPayable()}`);
    this.merchantFeeWrapper.html(`$${calculator.merchantFee().toFixed(2)}`);
  }

  buildLineItem(fieldset, subtotal) {
    let desc = fieldset.find(DESCRIPTION_INPUT).val();
    if (desc.length > 33) {
      desc = desc.substring(0, 33) + '...';
    }
    if (!isNaN(subtotal)) {
      return `
        <div class="row price-component">
          <div class="col-sm-9">${desc}</div>
          <dd class="col-sm-3" data-unit-price="${subtotal}">$${subtotal.toFixed(2)}</dd>
        </div>`;
    } else {
      return;
    }
  }

  submitForm() {
    this.submitButton.text(this.submitButton.data('disable-with'));
    this.form.submit();
  }
}

export default CompleteTimesheet;



// WEBPACK FOOTER //
// ./src/javascripts/CompleteTimesheet.js